/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StarHalfIcon24Solid = forwardRef('StarHalfIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 1.12a1.11 1.11 0 0 0-1.033.68l-2.53 5.875-6.37.591c-.984.091-1.381 1.314-.64 1.966l4.807 4.222-1.407 6.24c-.217.964.823 1.72 1.672 1.216L12 18.643V1.12Z" })));
});
